<template>
  <div>
    <app-header title=""></app-header>

    <div class="container my-5">
      <h2>Financial Targets</h2>

      <c-data-list :items="financialTargets">
        <template v-slot:columns>
          <div class="col-12 col-lg-6">
            <p>Financial Year</p>
          </div>
          <div class="col-4 col-lg-2">
            <p>Revenue Target</p>
          </div>
          <div class="col-4 col-lg-2">
            <p>Profit Target</p>
          </div>
          <div class="col-4 col-lg-2 text-end">
            <p>Sales Target</p>
          </div>
        </template>
        <template v-slot:default="slotProps">
          <financial-targets-list-item :financial-target="slotProps.item" />
        </template>
        <template v-slot:empty>
          No financial targets to show.
        </template>
      </c-data-list>
    </div>
  </div>
</template>

<script>
import FinancialTargetsListItem from './FinancialTargetsListItem'

export default {
  components: {
    FinancialTargetsListItem
  },

  data () {
    return {
      financialTargets: []
    }
  },

  created () {
    this.fetchData()
  },

  methods: {
    fetchData () {
      return client({ path: '/financial-targets' }).then((response) => {
        this.financialTargets = response.entity
      })
    }
  }
}
</script>
